<template>
  <router-view :key="$route.fullPath" />
</template>

<script>
import storeMixin, {
  unRegisterMixin
} from "@quisit/mipe-utils/mixins/storeGenerator";
const STORE_MODULE_NAME = "TransitionStudentModule";

export default {
  name: "WrapperTransitionStudentModule",
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME
  })
};
</script>
